<template>
  <div class="container">
    <el-form
      ref="modifyData"
      :model="modifyData"
      inline
      size="mini"
      label-width="58px"
      class="table-search-part inline-wrapper"
    >
      <div class="date-left">
        <el-form-item label="User Limit">
          <el-input class="small-input" v-model="modifyData.riskLevel"></el-input>
        </el-form-item>
        <el-form-item label="User Limit ID" v-if="queryData.riskLevelId" label-width="90px">
          <el-input class="small-input" v-model="queryData.riskLevelId" :disabled="true"></el-input>
        </el-form-item>
      </div>
      <!-- <div class="inline-right date-right">
        <el-button class="add-new-btn" @click="AddListRow()" style="width:180px">
          <i class="el-icon-plus"></i> Add Sport Settings
        </el-button>
      </div>-->
    </el-form>

    <div class="risk-table">
      <el-table
        ref="table"
        :data="list"
        :max-height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <el-table-column label="Sport" prop="sportId" min-width="113px">
          <template slot-scope="scope">
            <span v-if="scope.row.sportId !== 0">
              <el-select
                v-model="scope.row.sportId"
                placeholder="Sport"
                popper-class="table-select"
              >
                <el-option value="0" label="GENERAL"></el-option>
                <el-option
                  v-for="item in options"
                  :key="Number(item.code)"
                  :label="item.value"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </span>
            <span v-if="scope.row.sportId === 0">GENERAL</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Max Stake Per Day" prop="maxDailyStake" min-width="150px">
          <template slot-scope="scope">
            <span>
              <el-input
                size="mini"
                v-model="scope.row.maxDailyStake"
                :placeholder="detailList.maxDailyStake"
              ></el-input>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Max Profit Per Day" prop="maxDailyWinAmount" min-width="150px">
          <template slot-scope="scope">
            <span>
              <el-input
                size="mini"
                v-model="scope.row.maxDailyWinAmount"
                :placeholder="detailList.maxDailyWinAmount"
              ></el-input>
            </span>
          </template>
        </el-table-column>-->
        <el-table-column label="Max Stake Factor" prop="maxStakeFactor" min-width="140px">
          <template slot="header">
            <span>Max Stake Factor</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="The factor of the per bet limit"
              placement="top"
            >
              <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>
              <el-input
                size="mini"
                v-model="scope.row.maxStakeFactor"
                placeholder="100"
                @blur="inputMaxStake()"
                onkeyup="this.value=this.value.match(/\d+\.?\d{0,4}/);this.dispatchEvent(new Event('input'))"
              >
                <template slot="append">%</template>
              </el-input>
              <!-- <el-select
                v-model="scope.row.maxStakeFactor"
                placeholder="x1"
                popper-class="table-select"
              >
                <el-option
                  v-for="item in factorList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id*1"
                ></el-option>
              </el-select>-->
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Minimum Stake Factor" prop="minStakeFactor" min-width="140px">
          <template slot="header">
            <span>Minimum Stake Factor</span>
          </template>
          <template slot-scope="scope">
            <span>
              <el-input
                size="mini"
                v-model="scope.row.minStakeFactor"
                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<1)value=null"
                placeholder="1-100"
              ></el-input>
            </span>
          </template>
        </el-table-column>-->
        <el-table-column label="Self-Risk" prop="userCount" min-width="101px">
          <template v-slot="{row}">
            <el-select
              v-model="row.selfRisk"
              placeholder="OFF"
              popper-class="table-select"
              @change="selectRiskChange(row)"
            >
              <el-option
                v-for="item in selfRiskList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Pending Duration" min-width="120px">
          <template slot-scope="scope">
            <span>
              <el-select
                v-model="scope.row.pendingTime"
                placeholder="Select"
                popper-class="table-select"
              >
                <el-option
                  v-for="item in pendingList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id*1"
                ></el-option>
              </el-select>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Cashout" min-width="100px">
          <template slot-scope="scope">
            <div v-if="scope.row.sportId == 0">
              <el-switch
                v-model="scope.row.cashoutSwitch"
                :active-value="1"
                :inactive-value="0"
                active-color="#00A791"
                inactive-color="#D5D9E0"
                :width="35"
              ></el-switch>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="Super Limit" min-width="120px">
          <template slot="header">
            <span>Super Limit</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="Whether exceeded the default limit"
              placement="top"
            >
              <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div v-if="scope.row.sportId == 0">
              <el-switch
                v-model="scope.row.superLimit"
                :active-value="true"
                :inactive-value="false"
                active-color="#00A791"
                inactive-color="#D5D9E0"
                :width="35"
              ></el-switch>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="Single">
          <el-table-column
            label="Max Stake Per Match"
            prop="singleMaxStakePerMatch"
            min-width="135px"
          >
            <template slot-scope="scope">
              <span>
                <el-input
                  size="mini"
                  v-model="scope.row.singleMaxStakePerMatch"
                  :placeholder="detailList.singleMaxStakePerMatch"
                ></el-input>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Liability" prop="singleMaxLiability" min-width="90px">
            <template slot="header">
              <span>Liability</span>
              <el-tooltip
                class="item"
                effect="dark"
                content="Max possible win per single bet"
                placement="top"
              >
                <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>
                <el-input
                  size="mini"
                  onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  v-model="scope.row.singleMaxLiability"
                ></el-input>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="Liability Per Match"
            prop="singleMaxLiabilityPerMatch"
            min-width="145px"
          >
            <template slot="header">
              <span>Liability Per Match</span>
              <el-tooltip
                class="item"
                effect="dark"
                content="Max possible win per match"
                placement="top"
              >
                <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>
                <el-input size="mini" v-model="scope.row.singleMaxLiabilityPerMatch"></el-input>
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Parlay">
          <el-table-column label="Liability" prop="multipleMaxLiability" min-width="100px">
            <template slot="header">
              <span>Liability</span>
              <el-tooltip
                class="item"
                effect="dark"
                content="Max possible win per parlay bet"
                placement="top"
              >
                <i class="el-icon-warning-outline" style="color: red;margin-left: 6px;"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.sportId == 0">
                <el-input
                  size="mini"
                  onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  v-model="scope.row.multipleMaxLiability"
                ></el-input>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Max Stake Per Match"
            prop="multipleMaxStakePerMatch"
            min-width="135px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.sportId == 0">
                <el-input
                  size="mini"
                  v-model="scope.row.multipleMaxStakePerMatch"
                  :placeholder="detailList.multipleMaxStakePerMatch"
                ></el-input>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="Max Stake Per Day" prop="multipleMaxDailyStake" min-width="135px">
            <template slot-scope="scope">
              <span v-if="scope.row.sportId == 0">
                <el-input
                  size="mini"
                  v-model="scope.row.multipleMaxDailyStake"
                  :placeholder="detailList.multipleMaxDailyStake"
                ></el-input>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Operation" min-width="200px">
          <template slot-scope="scope">
            <div>
              <el-button class="table-inner-btn" @click="CloneListRow(scope.row,scope.$index)">Clone</el-button>
              <el-button
                class="table-inner-btn"
                v-if="list.length>1"
                @click="handleDelete(scope.row,scope.$index)"
              >Delete</el-button>
            </div>
          </template>
        </el-table-column>-->
      </el-table>
    </div>

    <div class="remark-wrapper">
      <div class="remark-head">Remark</div>
      <div class="remark-contain">
        <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="modifyData.remark"></el-input>
      </div>
    </div>

    <div class="table-search-part btn-wrapper" v-if="queryData.riskLevelId">
      <el-button class="search-btn" @click="handleSave()">Save</el-button>
      <el-button class="clear-btn" @click="handleCancel()">Cancel</el-button>
    </div>

    <div class="table-search-part btn-wrapper" v-if="!queryData.riskLevelId">
      <el-button class="search-btn" @click="handleAddSave()">Save</el-button>
      <el-button class="clear-btn" @click="handleAddCancel()">Cancel</el-button>
    </div>

    <dia ref="dialogDom" class="label-dialog">
      <div class="dialog-footer table-search-part">
        <el-button class="search-btn" @click="Delete()">Confirm</el-button>
        <el-button class="clear-btn" @click="Close()">Cancel</el-button>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
//import options from "@/components/options";
import dia from "@/components/dialog/index";
import { getTcsSportList } from "@/api/memberDetail";
import { getRiskDetailsList, getRiskUpdate, getRiskAdd } from "@/api/risk";
export default {
  data() {
    return {
      list: [],
      loading: false,
      addTable: false,
      queryData: {
        riskLevelId: null
      },
      addQueryData: {
        riskLevelId: 0
      },
      modifyData: {
        riskLevel: "",
        riskLevelId: null,
        riskLevelSubReqList: [],
        riskLevelDeleteReqList: [],
        selfRisk: 0,
        remark: ""
      },
      tableHeight: window.innerHeight,
      index: 0,
      row: {},
      options: [],
      title: "Delete the Sport settings?",
      selfRiskList: [
        {
          id: 1,
          label: "ON"
        },
        {
          id: 0,
          label: "OFF"
        }
      ],
      factorList: [
        {
          id: "0.01",
          label: "x0.01"
        },
        {
          id: "0.1",
          label: "x0.1"
        },
        {
          id: "0.2",
          label: "x0.2"
        },
        {
          id: "0.5",
          label: "x0.5"
        },
        {
          id: "0.8",
          label: "x0.8"
        },
        {
          id: "1",
          label: "x1"
        },
        {
          id: "1.5",
          label: "x1.5"
        },
        {
          id: "2",
          label: "x2"
        },
        {
          id: "3",
          label: "x3"
        }
      ],
      pendingList: [
        {
          id: "5",
          label: "5s"
        },
        {
          id: "10",
          label: "10s"
        },
        {
          id: "15",
          label: "15s"
        },
        {
          id: "30",
          label: "30s"
        },
        {
          id: "60",
          label: "60s"
        },
        {
          id: "-1",
          label: "Manual"
        }
      ],

      detailList: {
        maxDailyStake: "",
        maxDailyWinAmount: "",
        multipleMaxDailyStake: "",
        multipleMaxStakePerMatch: "",
        multipleMinStake: "",
        singleMaxStakePerMatch: "",
        singleMinStake: "",
        maxStakeFactor: "",
        minStakeFactor: ""
      }
    };
  },
  methods: {
    inputMaxStake() {
      this.list.map(item => {
        if (item.maxStakeFactor < 0.0001) {
          item.maxStakeFactor = 0.0001;
        }
      });
    },
    // 修改list
    async getList() {
      this.loading = true;
      try {
        const res = await getRiskDetailsList(this.queryData);
        const data = res.data || {};
        this.modifyData.riskLevel = data.riskLevel;
        this.modifyData.remark = data.remark;
        this.modifyData.selfRisk = data.selfRisk;
        let selfRisk = data.selfRisk;
        let dataList = data.riskLevelDetailDTOList || [];
        for (var key in dataList) {
          if (dataList[key].cashoutSwitch == null) {
            dataList[key].cashoutSwitch = 1;
          }
          if (dataList[key].superLimit == null) {
            dataList[key].superLimit = true;
          }
          if (dataList[key].maxStakeFactor) {
            dataList[key].maxStakeFactor = +(
              Number(dataList[key].maxStakeFactor) * 100
            ).toFixed(4);
          }
          if (dataList[key].minStakeFactor) {
            dataList[key].minStakeFactor = dataList[key].minStakeFactor;
          }
          dataList[key].selfRisk = selfRisk;
        }
        this.list = dataList;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || [];
        this.options = data;
      } catch (error) {
        this.options = [];
      }
    },
    selectRiskChange(val) {
      this.modifyData.selfRisk = val.selfRisk;
    },
    // 修改list
    async getAddDetailList() {
      this.loading = true;
      try {
        const res = await getRiskDetailsList(this.addQueryData);
        const data = res.data || {};
        this.detailList.maxDailyStake =
          data.riskLevelDetailDTOList[0].maxDailyStake;
        this.detailList.maxDailyWinAmount =
          data.riskLevelDetailDTOList[0].maxDailyWinAmount;
        this.detailList.multipleMaxDailyStake =
          data.riskLevelDetailDTOList[0].multipleMaxDailyStake;
        this.detailList.multipleMaxStakePerMatch =
          data.riskLevelDetailDTOList[0].multipleMaxStakePerMatch;
        this.detailList.multipleMinStake =
          data.riskLevelDetailDTOList[0].multipleMinStake;
        this.detailList.singleMaxStakePerMatch =
          data.riskLevelDetailDTOList[0].singleMaxStakePerMatch;
        this.detailList.singleMinStake =
          data.riskLevelDetailDTOList[0].singleMinStake;
        this.detailList.maxStakeFactor =
          data.riskLevelDetailDTOList[0].maxStakeFactor;
        this.detailList.minStakeFactor =
          data.riskLevelDetailDTOList[0].minStakeFactor;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    // 添加 list
    getAddList() {
      this.list = [
        {
          sportId: 0,
          maxDailyStake: "",
          maxDailyWinAmount: "",
          pendingTime: "",
          cashoutSwitch: 1,
          superLimit: true,
          singleMinStake: "",
          singleMaxStake: "",
          singleMaxStakePerMatch: "",
          singleMaxLiability: "",
          singleMaxLiabilityPerMatch: "",
          multipleMinStake: "",
          maxStakeFactor: "",
          minStakeFactor: "",
          // "multipleMaxStake":'',
          multipleMaxLiability: "",
          multipleMaxStakePerMatch: "",
          multipleMaxDailyStake: ""
        }
      ];
    },
    // 删除
    handleDelete(row, index) {
      this.$refs["dialogDom"].isShowDia(this.title, true, "323px");
      this.index = index;
      this.row = row;
    },
    Delete() {
      this.list.splice(this.index, 1);
      if (this.row.id) {
        this.modifyData.riskLevelDeleteReqList.push(this.row);
      }
      this.Close();
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false);
    },
    // 添加
    AddListRow() {
      this.list.push({
        maxDailyStake: "",
        maxDailyWinAmount: "",
        pendingTime: "",
        cashoutSwitch: 1,
        superLimit: true,
        singleMinStake: "",
        singleMaxStake: "",
        singleMaxStakePerMatch: "",
        singleMaxLiability: "",
        singleMaxLiabilityPerMatch: "",
        multipleMinStake: "",
        maxStakeFactor: "",
        minStakeFactor: "",
        // "multipleMaxStake":'',
        multipleMaxLiability: "",
        multipleMaxStakePerMatch: "",
        multipleMaxDailyStake: ""
      });
    },
    // 克隆
    CloneListRow(row) {
      this.list.push({
        maxDailyStake: row.maxDailyStake,
        maxDailyWinAmount: row.maxDailyWinAmount,
        pendingTime: row.pendingTime,
        cashoutSwitch: row.cashoutSwitch,
        superLimit: row.superLimit,
        singleMinStake: row.singleMinStake,
        singleMaxStake: row.singleMaxStake,
        singleMaxStakePerMatch: row.singleMaxStakePerMatch,
        singleMaxLiability: row.singleMaxLiability,
        singleMaxLiabilityPerMatch: row.singleMaxLiabilityPerMatch,
        multipleMinStake: row.multipleMinStake,
        maxStakeFactor: row.maxStakeFactor,
        minStakeFactor: row.minStakeFactor,
        // "multipleMaxStake":row.multipleMaxStake,
        multipleMaxLiability: row.multipleMaxLiability,
        multipleMaxStakePerMatch: row.multipleMaxStakePerMatch,
        multipleMaxDailyStake: row.multipleMaxDailyStake
      });
    },
    // 修改保存
    async handleSave() {
      this.modifyData.riskLevelSubReqList = this.list;
      this.modifyData.riskLevelId = this.queryData.riskLevelId;
      for (var key in this.modifyData.riskLevelSubReqList) {
        if (this.modifyData.riskLevelSubReqList[key].sportId == undefined) {
          this.$message({
            message: "Sport can not be empty",
            type: "warning"
          });
          return false;
        }
      }
      for (var key in this.modifyData.riskLevelSubReqList) {
        if (this.modifyData.riskLevelSubReqList[key].maxStakeFactor) {
          this.modifyData.riskLevelSubReqList[key].maxStakeFactor = Number(
            this.modifyData.riskLevelSubReqList[key].maxStakeFactor / 100
          ).toFixed(6);
        }
      }
      for (var key in this.modifyData.riskLevelSubReqList) {
        if (this.modifyData.riskLevelSubReqList[key].minStakeFactor) {
          this.modifyData.riskLevelSubReqList[
            key
          ].minStakeFactor = this.modifyData.riskLevelSubReqList[
            key
          ].minStakeFactor;
        }
      }
      if (this.modifyData.riskLevel) {
        const res = await getRiskUpdate(this.modifyData);
        if (res.code == 0) {
          this.$message({ message: "update success", type: "success" });
          this.$router.push({
            path: "/risk/detail",
            query: { riskLevelId: this.modifyData.riskLevelId }
          });
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
      } else {
        this.$message({
          message: "User Limit can not be empty",
          type: "warning"
        });
      }
    },
    // 添加保存
    async handleAddSave() {
      this.modifyData.riskLevelSubReqList = this.list;
      for (var key in this.modifyData.riskLevelSubReqList) {
        if (this.modifyData.riskLevelSubReqList[key].sportId == undefined) {
          this.$message({
            message: "Sport can not be empty",
            type: "warning"
          });
          return false;
        }
      }
      for (var key in this.modifyData.riskLevelSubReqList) {
        if (this.modifyData.riskLevelSubReqList[key].maxStakeFactor) {
          this.modifyData.riskLevelSubReqList[key].maxStakeFactor = Number(
            this.modifyData.riskLevelSubReqList[key].maxStakeFactor / 100
          ).toFixed(6);
        }
      }
      for (var key in this.modifyData.riskLevelSubReqList) {
        if (this.modifyData.riskLevelSubReqList[key].minStakeFactor) {
          this.modifyData.riskLevelSubReqList[
            key
          ].minStakeFactor = this.modifyData.riskLevelSubReqList[
            key
          ].minStakeFactor;
        }
      }
      if (this.modifyData.riskLevel) {
        const res = await getRiskAdd(this.modifyData);
        if (res.code == 0) {
          this.$message({ message: "add success", type: "success" });
          this.$router.push({ path: "/risk" });
        } else {
          this.$message({ message: res.message, type: "warning" });
        }
      } else {
        this.$message({
          message: "User Limit can not be empty",
          type: "warning"
        });
      }
    },
    // 修改取消
    handleCancel() {
      this.$router.push({
        path: "/risk/detail",
        query: { riskLevelId: this.queryData.riskLevelId }
      });
    },
    // 添加取消
    handleAddCancel() {
      this.$router.push({
        path: "/risk"
      });
    }
  },
  components: {
    dia
  },
  activated() {
    //this.getSportList();
    if (this.$route.query.riskLevelId) {
      this.queryData.riskLevelId = this.$route.query.riskLevelId;
      this.getList();
    } else {
      this.getAddDetailList();
      this.getAddList();
      this.addTable = true;
      this.modifyData.riskLevel = "";
    }
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 224;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 224;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.inline-wrapper {
  margin: 10px 0 15px;
}
.btn-wrapper {
  margin: 10px 0 0 0;
}
.date-left {
  width: 60% !important;
}
.date-right {
  width: 40% !important;
}
/deep/.el-input-group__append {
  padding: 0 5px !important;
}
/deep/.risk-table {
  .el-table th {
    padding: 6px 0;
  }
}
</style>
